// Email addresses are case-insensitive, but the backend matches the stored value verbatim,
// so "User@Mail.com" would fail to sign in an account registered as "user@mail.com".
// Trimming covers the space a mobile keyboard or a copy-paste appends.
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();
